<template>
  <b-modal
    id="custom-field-modal"
    ref="customFieldModal"
    :title="`${update ? 'Update': 'Create New'} Contact Field`"
    hide-footer
    size="md"
    @hidden="clear">
    <label
      class="col-form-label pt-0">
      Name
    </label>
    <b-form-group>
      <b-input
        v-model="name"
        placeholder="Add Name"
        autofocus/>
      <span
        v-if="validationErrors.name"
        class="validation-error clearfix">
        {{ validationErrors.name }}
      </span>
    </b-form-group>
    <label
      class="col-form-label pt-0">
      Type
    </label>
    <b-form-group>
      <b-select
        v-model="type"
        :options="fieldTypes"
        :disabled="update"
        value-field="alias"
        text-field="name"
        placeholder="Select Type"/>
      <span
        v-if="validationErrors.type"
        class="validation-error">{{ validationErrors.type }}</span>
    </b-form-group>
    <b-form-group v-if="type === 'list'">
      <label
        class="col-form-label pt-0">
        Options
      </label>
      <b-input-group
        v-for="(option, id) in options"
        :key="id"
        class="mb-1">
        <b-input
          v-model="option.name"
          :class="{borderize: options.length === 1}"
          placeholder="Option"
          :autofocus="addOptionClicked"/>
        <b-input-group-text
          slot="append"
          :disabled="options.length === 1"
          class="btn btn-main danger"
          @click="options.length > 1 ? deleteOption(option.value) : null">
          <icon
            name="minus"
            class="m-0"/>
        </b-input-group-text>
      </b-input-group>
      <div class="mt-2">
        <span
          class="add-data"
          @click="addOption">
          <icon
            width="12"
            height="12"
            name="plus"/> Add Option
        </span>
      </div>
    </b-form-group>
    <span
      v-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </span>
    <b-button
      :class="{loading: saving}"
      :disabled="saving"
      class="btn-round btn-block mt-4 mb-4"
      @click="saveField">
      <span v-if="!saving">Save</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import fieldTypes from '@/helpers/lists/fieldTypes';
import randomString from '@/helpers/randomString';
import setValidationErrors from '@/helpers/validationErrors';

export default {
  name: 'CustomFieldModal',
  props: {
    fieldp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      type: 'text',
      options: [{ value: `temp-${randomString()}`, name: '' }],
      fieldTypes,
      update: false,
      saving: false,
      errorMessage: '',
      validationErrors: {},
      addOptionClicked: false,
    };
  },
  computed: {
    ...mapGetters({
      customFieldSaved: 'contact/customFieldSaved',
      apiError: 'contact/apiError',
    }),
  },
  watch: {
    customFieldSaved(saved) {
      if (saved) {
        this.saving = false;
        this.$emit('saved', saved);
        this.hide();
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  methods: {
    ...mapActions({
      createCustomField: 'contact/createCustomField',
      updateCustomField: 'contact/updateCustomField',
    }),
    setFieldData() {
      if (!this.$lodash.isEmpty(this.fieldp)) {
        this.update = true;
        this.name = this.fieldp.name;
        this.type = this.fieldp.type;
        this.options = this.fieldp.options;
      } else {
        this.clear();
      }
    },
    addOption() {
      this.options.push({ value: `temp-${randomString()}`, name: '' });
      this.addOptionClicked = true;
    },
    deleteOption(option) {
      this.options = this.$lodash.filter(this.options, optionItem => optionItem.value !== option);
    },
    saveField() {
      this.saving = true;
      const data = {
        name: this.name,
        type: this.type,
        options: this.type === 'list' ? this.options : null,
      };

      if (this.update) {
        this.updateCustomField({
          merchant_id: this.$route.params.merchant_id,
          field_id: this.fieldp.id,
          data,
        });
      } else {
        this.createCustomField({
          merchant_id: this.$route.params.merchant_id,
          data,
        });
      }
    },
    show() {
      this.setFieldData();
      this.$refs.customFieldModal.show();
    },
    clear() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    hide() {
      this.$refs.customFieldModal.hide();
    },
  },
};
</script>
